/** @jsxImportSource ../../i18n */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { FOCUSABLE, IconButton, trapFocus } from '../ui';
import { Sidebar } from './Sidebar';

export const MobileDrawer = ({ open, onClose }) => {
  const panel = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const node = panel.current;
    node?.querySelector(FOCUSABLE)?.focus();
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onCloseRef.current?.();
      } else if (event.key === 'Tab' && node) {
        trapFocus(event, node);
      }
    };
    document.addEventListener('keydown', onKeyDown, true);
    return () => {
      document.removeEventListener('keydown', onKeyDown, true);
      document.body.style.overflow = overflow;
      previous?.focus?.();
    };
  }, [open]);

  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-drawer lg:hidden">
      <div className="absolute inset-0 animate-fade-in bg-black/60 backdrop-blur-sm" aria-hidden="true" onMouseDown={() => onCloseRef.current?.()} />
      <div ref={panel} role="dialog" aria-modal="true" aria-label="Menu principal" className="absolute inset-y-0 left-0 w-[288px] max-w-[85vw] animate-drawer-in border-r border-line bg-surface-1 shadow-pop">
        <Sidebar onNavigate={() => onCloseRef.current?.()} />
        <IconButton icon={X} label="Fermer le menu" tooltip={false} onClick={() => onCloseRef.current?.()} className="absolute right-3 top-3" />
      </div>
    </div>,
    document.body,
  );
};
